import script from "./CustomTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTooltip.vue?vue&type=script&setup=true&lang=js"

import "./CustomTooltip.vue?vue&type=style&index=0&id=4bfcd8fa&lang=css"

const __exports__ = script;

export default __exports__